// @ts-nocheck
import React, { useState } from 'react';

interface ColumnOption {
  id: string;
  label: string;
  defaultVisible?: boolean;
}

interface AdminColumnToggleProps {
  columns: ColumnOption[];
  visibleColumns: string[];
  onToggle: (columnId: string) => void;
  onToggleAll: (visible: boolean) => void;
  className?: string;
}

export const AdminColumnToggle: React.FC<AdminColumnToggleProps> = ({
  columns,
  visibleColumns,
  onToggle,
  onToggleAll,
  className = '',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const allVisible = visibleColumns.length === columns.length;
  const noneVisible = visibleColumns.length === 0;

  return (
    <div className={`relative ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 rounded-lg border border-luna-secondary/30 bg-white dark:bg-luna-primary text-luna-text-light dark:text-luna-text-dark hover:bg-luna-secondary/10 transition-colors text-sm min-h-[44px] touch-manipulation w-full sm:w-auto"
        title="Toggle columns"
      >
        <span className="material-symbols-outlined text-base">view_column</span>
        <span className="hidden sm:inline">Columns</span>
        <span className="text-xs text-luna-text-light/50 dark:text-luna-text-dark/50">
          ({visibleColumns.length}/{columns.length})
        </span>
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 top-full mt-2 bg-white dark:bg-luna-primary rounded-lg border-2 border-luna-secondary/30 shadow-xl z-20 min-w-[200px]">
            <div className="p-3 border-b border-luna-secondary/10">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-semibold text-luna-text-light dark:text-luna-text-dark">
                  Columns
                </span>
                <div className="flex gap-1">
                  <button
                    onClick={() => {
                      onToggleAll(true);
                      setIsOpen(false);
                    }}
                    disabled={allVisible}
                    className="px-2 py-1 text-xs rounded hover:bg-luna-secondary/10 disabled:opacity-50 disabled:cursor-not-allowed text-luna-text-light dark:text-luna-text-dark"
                  >
                    All
                  </button>
                  <button
                    onClick={() => {
                      onToggleAll(false);
                      setIsOpen(false);
                    }}
                    disabled={noneVisible}
                    className="px-2 py-1 text-xs rounded hover:bg-luna-secondary/10 disabled:opacity-50 disabled:cursor-not-allowed text-luna-text-light dark:text-luna-text-dark"
                  >
                    None
                  </button>
                </div>
              </div>
            </div>
            <div className="p-2 max-h-64 overflow-y-auto">
              {columns.map((column) => {
                const isVisible = visibleColumns.includes(column.id);
                return (
                  <label
                    key={column.id}
                    className="flex items-center gap-2 px-2 py-1.5 rounded hover:bg-luna-secondary/5 cursor-pointer"
                  >
                    <input
                      type="checkbox"
                      checked={isVisible}
                      onChange={() => onToggle(column.id)}
                      className="rounded border-luna-secondary/30"
                    />
                    <span className="text-sm text-luna-text-light dark:text-luna-text-dark">
                      {column.label}
                    </span>
                  </label>
                );
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

